import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { SelectInput } from 'components/forms'
import { IxObjectRangeLookup } from 'components/forms/lookups'
import ResponsiveBox, { Row, Col, Item, Location } from 'devextreme-react/responsive-box'
import { IxField } from 'components/forms/field'
import { Form, useFormikContext } from 'formik'
import { BaseForm } from 'components'
import { IxLookupProvider } from 'contexts/lookup-context'

import { useTranslation } from 'react-i18next'
import { RootState } from 'slices'
import { useIxGlobalFilter } from 'contexts/global-filter-context'
import { DrawerState } from 'helpers/drawer-state-enum'
import './global-filter.scss'

const AutoUpdateForm = () => {
    const { setObjectFilter, setFromFilter } = useIxGlobalFilter()

    const {
        values,  // eslint-disable-line @typescript-eslint/no-unused-vars
    } = useFormikContext<any>()

    useEffect(() => {
        setObjectFilter(values.objectFilter)
    },[values.objectFilter, setObjectFilter])

    useEffect(() => {
        setFromFilter(values.fromFilter)
    },[values.fromFilter, setFromFilter])
    return null
}

export const GlobalFilter = () => {
    const drawerState = useSelector((state: RootState) => state.ui.drawerState)
    const { t } = useTranslation()
    
    const fromOptions = useMemo(() => ([
        { value: 'all', text: t('global:timeRange.all') },
        { value: 'today', text: t('global:timeRange.today') },
        { value: '7days', text: t('global:timeRange.lastSevenDays') },
        { value: '30days', text: t('global:timeRange.lastThirtyDays') },
        { value: 'thisYear', text: t('global:timeRange.currentYear') },
        { value: 'lastYear', text: t('global:timeRange.lastYear') },
    ]),[t])
   
    const formik = useMemo(() => ({
        initialValues: {
            objectFilter: null,
            fromFilter: null,
        },
        enableReinitialize: true,
        jsonSchema: null,
        avjOptions: {
            coerceTypes: true,
            $data: true,
        },
    }), [])

    return (
        <BaseForm {...formik}>
            <IxLookupProvider>
                <AutoUpdateForm />
                <Form  id='global-filters' className='globalFilter' style={{marginLeft: drawerState === DrawerState.Closed ? '40px' : ''}}>
                    <ResponsiveBox>
                        <Row />

                        <Col />
                        <Col />
                        <Col />
                        <Col />
                        <Col />
                        <Col />

                        <Item>
                            <Location row={ 0 } col={ 0 } />
                            
                            <div className='item-div'>
                                <IxField
                                    as={ IxObjectRangeLookup }
                                    name='objectFilter'
                                    label={`${t('global:field.OBJGRUPPE')}:`}
                                    readOnly={false}
                                />
                            </div>
                        </Item>
                        <Item>
                            <Location row={ 0 } col={ 1 } />
                            
                            <div className='item-div'>
                                <IxField
                                    as={ SelectInput }
                                    name='fromFilter'
                                    opts={fromOptions}
                                    label={`${t('global:field.LASTCHANGE')}:`}
                                    displayExpr='text'
                                />
                            </div>
                        </Item>
                    </ResponsiveBox>
                </Form>
            </IxLookupProvider>
        </BaseForm>
    )
}
